/**
 * @requires ./frc.js
 */

 frc.pages.menuDetail = {

    "init": function() {
        var self = frc.page = frc.pages.menuDetail;

        $('#menu-dropdown').on('selecta-init', function() {
            $('.menu-nav-dropdown').addClass('loaded');
        }).on('change', function(e) {
            var url = $(e.target).val();
            window.location.href = url;
        }).Selecta({
            nativeOnMobile: true,
            forceRenderBelow: true
        });

        var ww = $(window).width();

        self.pinNav();
        
        $(window).on('resize', function() { 
            if ($(window).width() != ww && !$('.menu-nav-dropdown').data('pinUp')) {
                self.pinNav();
            }
        });
    },

    "pinNav": function() {
        if ($('.mobile-nav-switch').css('display') != 'none') {
            $('.menu-nav-dropdown').pinUp({
                class: 'pinned',
                container: 'section.menu',
                offset: {
                    element: '.nav-container'
                }
            });
        }
    }
 };